import * as colors from "../styles/colors";
import * as actionTypes from "../actionTypes";

export function setActiveSearchId(searchId) {
	return {
		type: actionTypes.UI_SET_ACTIVE_SEARCH_ID,
		searchId,
	};
}

export function setActiveReportSearchId(reportSearchId) {
	return {
		type: actionTypes.UI_SET_ACTIVE_REPORT_SEARCH_ID,
		reportSearchId,
	};
}

export function setBinderFromRoute(routerState) {
	return dispatch => {
		const params = routerState.params;

		const binderId = params.binderId ? parseInt(params.binderId, 10) : null;
		const tabIndex = params.tabIndex ? parseInt(params.tabIndex, 10) : null;
		const binderTabId =
			binderId !== null &&
			binderId !== undefined &&
			tabIndex !== null &&
			tabIndex !== undefined
				? `${binderId}-${tabIndex}`
				: null;

		return dispatch(setCurrentBinder(binderId, binderTabId));
	};
}

export function setCurrentBinder(binderId, binderTabId) {
	return {
		type: actionTypes.UI_SET_CURRENT_BINDER,
		binderId,
		binderTabId,
	};
}

export function setBinderTabDrawerOpen(open) {
	return {
		type: actionTypes.UI_SET_BINDER_TAB_DRAWER_OPEN,
		open,
	};
}

export function setBinderTabDrawerType(open, drawerType) {
	return {
		type: actionTypes.UI_SET_BINDER_TAB_TYPE,
		drawerType,
		open,
	};
}

export function setChangeWarningOpen(open) {
	return {
		type: actionTypes.UI_SET_CHANGE_WARNING_OPEN,
		open,
	};
}

export function setPrintPreview(printPreview) {
	return dispatch => {
		if (printPreview) {
			document.body.style.overflowY = "auto";
			document.body.style.overflowX = "auto";
			document.body.style.backgroundColor = colors.white;
		} else {
			document.body.style.overflowY = "hidden";
			document.body.style.overflowX = "visible";
			document.body.style.backgroundColor = colors.docketDarkBlue3;
		}

		dispatch({
			type: actionTypes.UI_SET_PRINT_PREVIEW,
			printPreview,
		});
	};
}

export function setPrintPreviewDetails(printPreviewDetails) {
	return {
		type: actionTypes.UI_SET_PRINT_PREVIEW_DETAILS,
		printPreviewDetails,
	};
}
